import { render, staticRenderFns } from "./SystemWarningModal.vue?vue&type=template&id=3c4d29bf&scoped=true"
import script from "./SystemWarningModal.vue?vue&type=script&lang=js"
export * from "./SystemWarningModal.vue?vue&type=script&lang=js"
import style0 from "./SystemWarningModal.vue?vue&type=style&index=0&id=3c4d29bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4d29bf",
  null
  
)

export default component.exports